import { Reducer } from 'redux';

import { IAuthState } from 'types/auth.types';
import * as constants from 'redux/constants/auth.constants';

export const defaultState: IAuthState = {
  data: null,
  initializing: true,
  loading: false,
  message: null,
};

const userReducer: Reducer = (state = defaultState, action) => {
  const { data, error, type } = action;
  switch (type) {
    case constants.AUTH_ON_LOGIN_REQUESTED:
    case constants.AUTH_ON_LOGOUT_REQUESTED:
    case constants.AUTH_ON_LOGIN_PUBLIC_REQUESTED:
    case constants.AUTH_ON_LOGOUT_PUBLIC_REQUESTED:
    case constants.AUTH_ON_REGISTER_PUBLIC_REQUESTED:
    case constants.AUTH_ON_RESET_PASSWORD_REQUESTED:
    case constants.AUTH_ON_CHANGE_PASSWORD_REQUESTED:
      return {
        ...state,
        loading: true,
        message: data?.message || null,
      };
    case constants.AUTH_ON_INITIALIZE_SUCCEEDED:
      return {
        ...state,
        data: data.user,
        initializing: false,
      };
    case constants.AUTH_ON_LOGIN_SUCCEEDED:
    case constants.AUTH_ON_LOGIN_PUBLIC_SUCCEEDED:
    case constants.AUTH_ON_REGISTER_PUBLIC_SUCCEEDED:
    case constants.AUTH_ON_RESET_PASSWORD_SUCCEEDED:
    case constants.AUTH_ON_CHANGE_PASSWORD_SUCCEEDED:
      return {
        ...state,
        data: data.user,
        loading: false,
        message: data?.message || null,
      };
    case constants.AUTH_ON_REGISTER_PUBLIC_FAILED:
      return {
        ...state,
        loading: false,
        message:
          error?.response.data.errors[0] || error?.response.data.message || 'Error en la operación',
      };
    case constants.AUTH_ON_INITIALIZE_FAILED:
      return {
        ...state,
        initializing: false,
      };
    case constants.AUTH_ON_LOGOUT_SUCCEEDED:
    case constants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
    case constants.AUTH_ON_LOGIN_FAILED:
    case constants.AUTH_ON_LOGIN_PUBLIC_FAILED:
    case constants.AUTH_ON_RESET_PASSWORD_FAILED:
    case constants.AUTH_ON_CHANGE_PASSWORD_FAILED:
      return {
        ...defaultState,
        initializing: false,
        loading: false,
      };
    case constants.AUTH_ON_LOGOUT_FAILED:
    case constants.AUTH_ON_LOGOUT_PUBLIC_FAILED:
    default:
      return error?.response?.status === 401 ? defaultState : state;
  }
};

export default userReducer;
